<script lang="ts">
  import { getModalStore } from '@skeletonlabs/skeleton';
  import { Button } from '$lib/components/button';

  /** Default: `max-w-xl` */
  export let width = 'max-w-xl';

  const modalStore = getModalStore();
</script>

{#if $modalStore[0]}
  <!-- Container -->
  <div class="card w-full space-y-4 p-8 shadow-xl {width}">
    <div class="mb-6 flex items-start justify-between">
      <!-- Title -->
      <header class="text-2xl font-bold">{$modalStore[0].title}</header>

      <!-- Close -->
      <Button icon="x" iconWidth="w-[22px]" padding="p-0" onClick={() => modalStore.close()} />
    </div>

    <!-- Content -->
    <slot />
  </div>
{/if}
